import React, { useEffect, useState } from "react";
import CustomerHeader from "../Common/CustomerHeader";
import Stepper from "../Common/Stepper";
import CustomerInput from "../reusableComponents/CustomerInput";
import { useNavigate } from "react-router-dom";
import {
  addUpdateEmailServerData,
  DetailsApi,
} from "../../services/redux/ApiActions";
import { useDispatch, useSelector } from "react-redux";
import showNotification from "../../services/redux/NotifcationService";
import LogoDiv from "../Common/LogoDiv";

export default function EmailServerPage() {
  const customerData = useSelector(
    (state) => state?.customerData?.customerData,
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const details = useSelector((state) => state?.details?.details);

  useEffect(() => {
    getDetails();
  }, []);

  const getDetails = async () => {
    const Payload = {
      id: customerData?.custId,
    };
    // console.log(Payload)
    const res = await dispatch(
      DetailsApi(Payload, customerData?.token_chr, "customer"),
    );
    setData((prevData) => ({
      ...prevData,
      programId: res?.result?.programId,
    }));
    if (res.result.emailServerDetails !== null) {
      setData((prevData) => ({
        ...prevData,
        programId: res?.result?.programId,
        smtp: res?.result?.emailServerDetails?.smtp,
        port: res?.result?.emailServerDetails?.port,
        username: res?.result?.emailServerDetails?.username,
        password: res?.result?.emailServerDetails?.password,
      }));
    } else {
      setData((prevData) => ({
        ...prevData,
      }));
    }
  };

  // addUpdateEmailServerData
  const handleSubmit = async () => {
    if (data?.smtp === "" || data?.smtp === undefined) {
      showNotification("SMTP server name is required", "error");
    } else if (data?.port === "" || data?.port === undefined) {
      showNotification("Port number is required", "error");
    } else if (data?.username === "" || data?.username === undefined) {
      showNotification("Username is required", "error");
    } else if (data?.password === "" || data?.password === undefined) {
      showNotification("Password is required", "error");
    } else {
      const payload = {
        customerId: customerData?.custId,
        SMTP: data?.smtp,
        Port: data?.port,
        Username: data?.username,
        Password: data?.password,
      };
      const res = await dispatch(
        addUpdateEmailServerData(payload, customerData?.token_chr),
      );
      if (res.statusCode == 200) {
        showNotification(
          "Email details added or updated successfully",
          "success",
        );
        getDetails();
        navigate("/Customer/Step7");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let cleanedValue = value;

    switch (name) {
      default:
        // No restriction for other fields
        cleanedValue = value;
        break;
    }

    setData((prevData) => ({
      ...prevData,
      [name]: cleanedValue,
    }));
  };

  return (
    <>
      <body className="mailsentbody">
        <LogoDiv className="logoBG">
          <div className="rightElement">
            <CustomerHeader />
            <div className="grid mt-6 grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
              <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                <Stepper />
                <div className="bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                    <div className="col-span-12 md:col-span-8 lg:col-span-8">
                      <div className="py-2 text-center">
                        <h1 className="text-xl font-semibold letter-spacing">
                          Mail Server Detail
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="py-2 text-center">
                    <h1 className="text-sm text-gray-600">
                      Please provide details of the email account from where the
                      payment request will be sent to customers
                    </h1>
                  </div>
                  <div className="mt-2 border-none border-collapse rounded-md">
                    <div className="grid mt-6 grid-cols-12 gap-4">
                      <div className="col-span-12 md:col-span-12 lg:col-span-6">
                        <label
                          for="smtp"
                          className="block text-md font-medium leading-6 text-gray-900"
                        >
                          SMTP Server Name(e.g. smtp.gmail.com){" "}
                          <span className="text-red-600">*</span>
                        </label>
                        <CustomerInput
                          onChange={handleChange}
                          name="smtp"
                          placeHolder="ENTER SMTP SERVER"
                          inputStyles={{ padding: "12px" }}
                          value={data?.smtp || ""}
                        />
                      </div>
                      <div className="col-span-12 md:col-span-12 lg:col-span-6">
                        <label
                          for="port"
                          className="block text-md font-medium leading-6 text-gray-900"
                        >
                          Port Number(465 or 587)
                          <span className="text-red-600">*</span>
                        </label>
                        <CustomerInput
                          onChange={handleChange}
                          name="port"
                          placeHolder="ENTER PORT NUMBER"
                          inputStyles={{ padding: "12px" }}
                          value={data?.port || ""}
                        />
                      </div>
                      <div className="col-span-12 md:col-span-12 lg:col-span-6 ">
                        <label
                          for="username"
                          className="block text-md font-medium leading-6 text-gray-900"
                        >
                          Username (email id from which email will be sent)
                          <span className="text-red-600">*</span>
                        </label>
                        <CustomerInput
                          onChange={handleChange}
                          name="username"
                          placeHolder="ENTER USERNAME"
                          inputStyles={{ padding: "12px" }}
                          value={data?.username || ""}
                        />
                      </div>

                      <div className="col-span-12 md:col-span-12 lg:col-span-6">
                        <label
                          for="password"
                          className="block text-md font-medium leading-6 text-gray-900"
                        >
                          Password ( or API Password in case of gmail){" "}
                          <span className="text-red-600">*</span>
                        </label>
                        <CustomerInput
                          onChange={handleChange}
                          name="password"
                          placeHolder="ENTER PASSWORD"
                          inputStyles={{ padding: "12px" }}
                          value={data?.password || ""}
                        />
                      </div>
                    </div>

                    <div className="col-span-12 md:col-span-7 lg:col-span-7">
                      <div className="relative text-center">
                        <button
                          className="vtpRm-action-button"
                          onClick={handleSubmit}
                        >
                          Submit
                        </button>
                        {details?.result.lastCompletedStep >= 6 ? (
                          <>
                            <span
                              className="skip-btn hover:cursor-pointer py-4 px-4"
                              onClick={() => {
                                navigate("/Customer/Step7");
                              }}
                            >
                              Skip this step
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
            </div>
          </div>
        </LogoDiv>
      </body>
    </>
  );
}
